import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../../Tostador/Tostador.css";

export default function TotalizadorAguaMasa() {
  const initialFetch = new TostadorFetching().setIdSeccion(2).setSecuencia(6);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [aguaRecupConcentracion, setAguaRecupConcentracion] =
    useState(defaultObject);
  /*const [totalizadorEfluenteTratado, setTotalizadorEfluenteTratado] =
    useState(defaultObject);*/
  const [totalizadorCaudalLechadaCal, setTotalizadorCaudalLechadaCal] =
    useState(defaultObject);
  const [totalizadorArsenitoCalcio, setTotalizadorArsenitoCalcio] =
    useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);
      populateAguaRecupConcentracion(data);
      //populateTotalizadorEfluenteTratado(data);
      populateTotalizadorCaudalLechadaCal(data);
      populateTotalizadorArsenitoCalcio(data);
      setDateHook(data, "Agua Recuperada Tostación a Concentradora");
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateAguaRecupConcentracion(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) =>
        element.Detalle === "Agua Recuperada Tostación a Concentradora"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setAguaRecupConcentracion({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  /*function populateTotalizadorEfluenteTratado(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Efluente Tratado"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorEfluenteTratado({
      fecha: arrFechas,
      value: arrValues,
    });
  }*/

  function populateTotalizadorCaudalLechadaCal(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Caudal Lechada de Cal"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorCaudalLechadaCal({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorArsenitoCalcio(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Arsenito de Calcio"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorArsenitoCalcio({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={
              "Totalizador Efluente Tratado, Agua Recuperada  y Masa Arsenito"
            }
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Agua Recuperada Tostación a Concentradora --------------------------------------- 
            <Chart.Area
              name="Agua Recuperada Tostación a Concentradora"
              data={aguaRecupConcentracion.value}
              yAxis={0}
            />
            */}

            {/** -------------------------------- Totalizador Efluente Tratado --------------------------------------- 
            <Chart.Area
              name="Totalizador Efluente Tratado"
              data={totalizadorEfluenteTratado.value}
              yAxis={0}
            />*/}

            {/** -------------------------------- Totalizador Arsenito de Calcio --------------------------------------- */}
            <Chart.Area
              name="Totalizador Arsenito de Calcio"
              data={totalizadorArsenitoCalcio.value}
              yAxis={0}
            />

            {/** -------------------------------- Totalizador Caudal Lechada de Cal --------------------------------------- */}
            <Chart.Area
              name="Totalizador Caudal Lechada de Cal"
              data={totalizadorCaudalLechadaCal.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={aguaRecupConcentracion.fecha} />

            <Chart.YAxis
              labelSuffix=" t"
              title="Totalizador Arsenito, t"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis
              labelSuffix=" m3"
              title="Totalizador Lechada de Cal, m3"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
            />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
